// src/components/AdminLayout.js
import React from 'react';
import { getAuth, signOut } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import { uploadAccessCodes } from '../utils/uploadAccessCodes'; // ← Importert
import AccessCodeList from './AccessCodeList'; // ← Ny komponent

function AdminLayout({ children }) {
  const navigate = useNavigate();

  const handleLogout = async () => {
    const auth = getAuth();
    await signOut(auth);
    navigate('/'); // Tilbake til startsiden etter logg ut
  };

  return (
    <div className="min-h-screen bg-white text-black">
      {/* Topplinje */}
      <header className="flex justify-between items-center px-6 py-4 border-b border-gray-300 shadow">
        <h1 className="text-xl font-bold text-blue-600">Adminpanel</h1>
        <button
          onClick={handleLogout}
          className="bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded"
        >
          Logg ut
        </button>
      </header>

      {/* Innhold */}
      <main className="p-6">
        {children}

        {/* Knapp for opplasting av passord */}
        <div className="mt-8">
          <button
            onClick={uploadAccessCodes}
            className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded"
          >
            Last opp 30 passord til Firestore
          </button>
        </div>

        {/* Vis passordstatus */}
        <AccessCodeList />
      </main>
    </div>
  );
}

export default AdminLayout;
